import React, { Component } from "react";
import LessonCard from "../../../Components/Courses/LessonCard";
import Header from "../../../Components/MainLayout/Header";
import { connect } from "react-redux";
import Axios from "axios";
import Cover from "../../../Assets/img/default-cover-image.svg";
import noData from "../../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Lessons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courseDetails: {},
      course_cordinator_data: {},
      subject: {},
      coursesection: [],
      loadingDetail: true,
      loading: true,
      fakeData: [1, 2],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Online Lessons";
    this.fetchCourseDetail({
      id: this.props.match.params.Id,
    });
    this.fetchcoursesection({
      school: this.props.user.user.school.id,
      course: this.props.match.params.Id,
      ordering: "section_position",
      status: "true",
    });
  }

  fetchCourseDetail = (params = {}) => {
    Axios.get("/courseapi/course", { params: { ...params } })
      .then((res) => {
        this.setState({
          courseDetails: res.data[0],
          course_cordinator_data: res.data[0].course_cordinator,
          subject: res.data[0].subject,
          loadingDetail: false,
        });
      })
      .catch((error) => {
        this.setState({ loadingDetail: false });
      });
  };

  fetchcoursesection = (params = {}) => {
    Axios.get(`/courseapi/coursesection`, {
      params: { ...params },
    })
      .then((res) => {
        this.setState({
          coursesection: res.data.results,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <div>
        <Header to="/courses" title="Lessons" />

        {this.state.loadingDetail ? (
          <Skeleton height={250} style={{ lineHeight: 1.5 }} />
        ) : (
          <div
            className="bg-light overflow-hidden"
            style={{
              height: 250,
              backgroundImage: `url(${
                this.state.courseDetails.course_image
                  ? this.state.courseDetails.course_image
                  : Cover
              })`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          >
            <div
              className="p-3 d-flex align-items-end"
              style={{
                height: 250,
                background:
                  "linear-gradient(360deg, rgba(0, 0, 0, 0.81) 0%, rgba(0, 0, 0, 0.400781) 31.77%, rgba(0, 0, 0, 0) 100%)",
              }}
            >
              <div className="d-flex w-100">
                <div className="w-100">
                  <h6 className="th-white th-16">
                    {this.state.courseDetails.course_name}
                  </h6>
                  <p className="th-grey th-12 mb-0">
                    {this.state.course_cordinator_data.first_name}{" "}
                    {this.state.course_cordinator_data.last_name}
                  </p>
                </div>
                {this.state.course_cordinator_data.whatsapp_number ? (
                  <a
                    className="my-auto p-2"
                    href={`https://api.whatsapp.com/send?phone=${
                      this.state.course_cordinator_data.whatsapp_number
                    }&text=${this.state.courseDetails.course_name}-${
                      this.state.subject.subject
                    } (${this.props.user.user.first_name} ${
                      this.props.user.user.last_name
                        ? this.props.user.user.last_name
                        : ""
                    } | ${this.props.user.student_class.class_name} | ${
                      this.props.user.student_section.section_name
                    })`}
                    target="_blank"
                  >
                    <i
                      className="fa fa-4x fa-whatsapp text-success th-24"
                      aria-hidden="true"
                    ></i>
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        )}

        <div className="container py-3 col-12">
          <div>
            {this.state.loading ? (
              <div>
                {this.state.fakeData?.map((item, index) => (
                  <div key={index}>
                    <Skeleton width={120} />
                    <div className="border p-3 shadow-sm rounded-lg mb-3">
                      <Skeleton count={2} />
                    </div>
                  </div>
                ))}
              </div>
            ) : null}

            {this.state.coursesection.length !== 0 &&
            this.state.loading === false
              ? this.state.coursesection?.map((item, index) => (
                  <>
                    <LessonCard
                      key={index}
                      lessonNo={item.section_position}
                      name={item.section_name}
                      Section={item.id}
                    />
                  </>
                ))
              : null}
            {this.state.coursesection.length === 0 &&
            this.state.loading === false ? (
              <div className="px-5 py-5">
                <img className="w-100 mt-5" src={noData} alt="No Data Found" />
                <p className="text-center th-14 th-bold mt-5">
                  No Lessons to Show!
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(Lessons);
